import { TypeSystem } from "../../support/type-system.support";

    /**
     * @description
     *  Modelo de un nivel de campaña.
     *
     * @see gigot-backend/Controllers/Sales/CampaignLevelsController.cs
     */

export class CampaignLevel {

    public applicationUserFirstName: string;
	public applicationUserId: string;
	public applicationUserLastName: string;
	public applicationUserUserName: string;
	public campaignId: number;
	public children: CampaignLevel[];
	public id: number;
	public levelId: number;
	public levelName: string;
	public levelTypeId: number;
	public levelTypeName: string;
	public parentId: number;
	public parentLevelId: number;

    /**
     * @description
     *	Construye un nivel de campaña con una semántica vacía. Nótese que no
     *  es lo mismo que construir un nivel con valores por defecto. Las reglas
     *  generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un nivel de campaña vacío.
     */
    public static empty(): CampaignLevel {
        const campaignLevel: CampaignLevel = new CampaignLevel();
		campaignLevel.applicationUserFirstName = "";
		campaignLevel.applicationUserId = "";
		campaignLevel.applicationUserLastName = "";
		campaignLevel.applicationUserUserName = "";
		campaignLevel.campaignId = undefined;
		campaignLevel.children = [];
		campaignLevel.id = undefined;
		campaignLevel.levelId = undefined;
		campaignLevel.levelName = "";
		campaignLevel.levelTypeId = undefined;
		campaignLevel.levelTypeName = "";
		campaignLevel.parentId = undefined;
		campaignLevel.parentLevelId = undefined;
        return campaignLevel;
    }

	/**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicCampaignLevel
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
	public static from(anemicCampaignLevel: CampaignLevel): CampaignLevel {
		if (!anemicCampaignLevel) return undefined;
        const campaignLevel: CampaignLevel = CampaignLevel.empty();
		campaignLevel.applicationUserFirstName = anemicCampaignLevel.applicationUserFirstName;
		campaignLevel.applicationUserId = anemicCampaignLevel.applicationUserId;
		campaignLevel.applicationUserLastName = anemicCampaignLevel.applicationUserLastName;
		campaignLevel.applicationUserUserName = anemicCampaignLevel.applicationUserUserName;
		campaignLevel.campaignId = anemicCampaignLevel.campaignId;
		campaignLevel.children = TypeSystem.orElse(anemicCampaignLevel.children, [])
			.map(child => CampaignLevel.from(child));
		campaignLevel.id = anemicCampaignLevel.id;
		campaignLevel.levelId = anemicCampaignLevel.levelId;
		campaignLevel.levelName = anemicCampaignLevel.levelName;
		campaignLevel.levelTypeId = anemicCampaignLevel.levelTypeId;
		campaignLevel.levelTypeName = anemicCampaignLevel.levelTypeName;
		campaignLevel.parentId = anemicCampaignLevel.parentId;
		campaignLevel.parentLevelId = anemicCampaignLevel.parentLevelId;
        return campaignLevel;
    }
}
